import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons/faExclamationCircle';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons/faExclamationTriangle';
import { FormattedMessage } from 'react-intl';
import { Button } from 'ui-components/components/button';
import classnames from 'classnames';
import { noop } from 'ui-components/default-props/noop';

import { getMessageDescriptorOrStringFromErrorString } from '../../../../../errors/user-friendly-error-message-service/error-string-matching-to-formatted-message';

import style from './style.module.less';

const ACTIVE_LABEL_MESSAGE = 'Active Label';
const MAX_MESSAGE_LENGTH = 77; // this is the length of the already shipped warning message

const getOriginalOrReplacementMessage = (originalMessage) => {
  if (typeof originalMessage === 'string' && !originalMessage.trim() === ACTIVE_LABEL_MESSAGE) {
    return (
      <FormattedMessage
        defaultMessage='This shipment has already been shipped and will be ignored.'
        description='expandableMessage.activeLabel'
        id='aADbYI'
      />
    );
  }

  const shouldFormatMessage = true;
  return getMessageDescriptorOrStringFromErrorString(originalMessage, shouldFormatMessage);
};

const iconWrapper = (icon, isWarning = false) => {
  return (
    <div className={classnames(style['icon-wrap'], { [style.warning]: isWarning })}>
      <FontAwesomeIcon icon={icon} />
    </div>
  );
};

const showExpander = (onExpanded, isExpanded) => {
  return (
    <Button onClick={onExpanded} theme='link'>
      {!isExpanded && <FormattedMessage defaultMessage='show more' description='expandableMessage.more' id='NZ1HHi' />}
      {isExpanded && <FormattedMessage defaultMessage='show less' description='expandableMessage.less' id='depuaD' />}
    </Button>
  );
};

export const ExpandableMessage = ({ message = '', messageType = '', onExpanded = noop, isExpanded = false }) => {
  const shouldTruncate = message.length > MAX_MESSAGE_LENGTH;
  const classNames = classnames(style['expandable-message'], style['message-cell-truncated'], { [style.expanded]: isExpanded });
  const messageCellClasses = classnames(style['message-cell'], { [style.truncated]: !isExpanded }, { [style.expanded]: isExpanded });
  return (
    <div className={classNames}>
      <div className={classnames(style['icon-wrap-container'])}>
        {['activeLabelWarning', 'error'].includes(messageType) && iconWrapper(faExclamationCircle)}
        {messageType === 'warning' && iconWrapper(faExclamationTriangle, true)}
      </div>
      <div className={messageCellClasses}>
        <span className={style.message}>{getOriginalOrReplacementMessage(message)}</span>
        <span className={style.expander}>{shouldTruncate && showExpander(onExpanded, isExpanded)}</span>
      </div>
    </div>
  );
};

/**
 * @param {object} props
 * @param {string | import('react-intl').MessageDescriptor} [props.message] - Message to display
 * @param {'error' | 'warning' | 'activeLabelWarning'} [props.messageType] - Type of message
 * @param {() => void} [props.onExpanded] - Callback when expand/collapse is clicked
 * @param {boolean} [props.isExpanded] - Whether the message is expanded
 * @returns {JSX.Element}
 */
